module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-31c8e9b71dfb0afeaee94415961654f3.webp";